module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    class: _vm.pageData ? '' : 'loading'
  }, [_c('carousel', {
    attrs: {
      "slides": _vm.carousel
    }
  }), _vm._v(" "), _c('how-to-help'), _vm._v(" "), _c('our-story'), _vm._v(" "), _c('events', {
    attrs: {
      "events": _vm.events
    }
  }), _vm._v(" "), _c('our-team'), _vm._v(" "), _c('breakdown', {
    attrs: {
      "backpacks": _vm.backpacks,
      "countries": _vm.countries
    }
  }), _vm._v(" "), _c('ways-you-can-help'), _vm._v(" "), _c('donate'), _vm._v(" "), _c('media-inquiries'), _vm._v(" "), _c('contact-us')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-07c1b177!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 379
// module chunks = 2